import React from 'react';
import { Reveal } from '../ui/Reveal';

/** Placeholder band image — replace with a real coaching photo at least 3440px wide. */
const COACHING_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/4e1cc436-a51b-4b23-b0bc-daffcd9fc65a.jpg';
export function MentoringSection() {
  return <section id="mentoring" aria-labelledby="mentoring-heading" className="bg-white" data-id="element-148" data-mp="1hj9itn1w29re">
      <div className="px-fluid py-section grid gap-fluid lg:grid-cols-12" data-id="element-149" data-mp="12umrso2wftkc">
        <Reveal className="lg:col-span-5" data-id="element-150" data-mp="12tbn8m1mqhs6">
          <h2 id="mentoring-heading" className="text-h2 max-w-[16ch] font-extrabold text-brand-navy" data-id="element-151" data-mp="17mwp4p6cfvwn">
            Coaching Young Men for What Comes Next
          </h2>
        </Reveal>
        <Reveal delay={0.05} className="lg:col-span-7" data-id="element-152" data-mp="xvjy1zsdd9ro">
          <p className="text-lead max-w-[56ch]" data-id="element-153" data-mp="xtz3wb9yvsuc">
            On and off for 15 years I’ve coached high school football at multiple schools. It was never just about the
            game — it’s about mentoring young men who are about to head out into the world. I believe ages 15 to 21 are
            one of the most critical stretches of a person’s life, and the right push at the right time can change
            everything.
          </p>
        </Reveal>
      </div>

      <figure className="relative isolate flex min-h-[clamp(24rem,40vw,52rem)] items-center overflow-hidden" data-id="element-154" data-mp="3afkeojc4rhuv">
        <img src={COACHING_IMAGE} alt="A high school football field under stadium lights at dusk" loading="lazy" decoding="async" className="absolute inset-0 -z-20 h-full w-full object-cover" data-id="element-155" data-mp="35iaec8n7dls9" />
        <div aria-hidden="true" className="absolute inset-0 -z-10 bg-brand-navy/80" data-id="element-156" data-mp="2rij5snfggxln" />
        <Reveal className="px-fluid w-full py-[clamp(4rem,7vw,9rem)]" data-id="element-157" data-mp="2mr9j9vp7eadz">
          <blockquote className="max-w-[24ch] text-[clamp(1.75rem,0.9rem+2.6vw,5rem)] font-extrabold leading-[1.12] tracking-[-0.02em] text-white" data-id="element-158" data-mp="2mp6hyfilouty">
            <span aria-hidden="true" className="text-brand-accent" data-id="element-159" data-mp="1u3do4vfa8qjb">
              “
            </span>
            The right push at the right time can change everything.
            <span aria-hidden="true" className="text-brand-accent" data-id="element-160" data-mp="2yk8hw212uu5">
              ”
            </span>
          </blockquote>
          <figcaption className="mt-[clamp(1.25rem,2vw,2.5rem)] text-small-fluid font-semibold uppercase tracking-[0.18em] text-white/85" data-id="element-161" data-mp="7oqwbtopubbc">
            — David Moceri
          </figcaption>
        </Reveal>
      </figure>
    </section>;
}